import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory, useNavigate } from "react-router-dom";
import { Menu, MenuDiv } from "./Menu";
import JqxTabs from "jqwidgets-scripts/jqwidgets-react-tsx/jqxtabs";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material.css";
import "jqwidgets-scripts/jqwidgets/styles/jqx.base.css";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material-purple.css";
import "jqwidgets-scripts/jqwidgets/styles/jqx.summer.css";
import "jqwidgets-scripts/jqwidgets/styles/jqx.darkblue.css";
import Button from "@material-ui/core/Button";
import Tabs from "../components/Tabs";
import * as Util from "../utils/util.js";

const nullCheck = (text) => {
  if (text === "null") return "";
  else return text;
};

function Home(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [program, setProgram] = useState(
    (
      JSON.parse(window.sessionStorage.getItem("program")) ??
      location.state.program
    ).map((it, i) => ({
      ...it,
      IMAGE_URL: `${Util.isDebug() ? "" : "."}/images/${it.PROGRAM_ID.slice(
        -2
      )}.png`,
      SELECTED_IMAGE_URL: `${
        Util.isDebug() ? "" : "."
      }/images/${it.PROGRAM_ID.slice(-2)}-s.png`,
    }))
  );
  const [id, setId] = useState(
    location.state == undefined
      ? JSON.parse(window.sessionStorage.getItem("program"))
      : location.state.program.map((program) => program.PROGRAM_ID)
  );
  const refTabs = useRef();
  const [selectedProgramName, setSelectedProgramName] = useState("");

  useEffect(() => {
    if (window.sessionStorage.getItem("user_id") === null) {
      navigate("/", { replace: true });
    }
    logOut = logOut.bind(this);
  }, []);

  useEffect(() => {
    if (refTabs.current) {
      setSelectedProgramName(refTabs.current.getTitleAt(0));
    }
  }, [refTabs.current]);

  let logOut = () => {
    window.sessionStorage.clear();
    navigate("/", { replace: true });
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Tabs
          vertical
          ref={refTabs}
          onSelected={(e) => {
            setSelectedProgramName(refTabs.current.getTitleAt(e.args.item));
          }}
          onLogOut={logOut}
        >
          <ul style={{ marginLeft: 4, backgroundColor: "rgb(12,126,177)" }}>
            {program.map((program) => (
              <li
                key={program.PROGRAM_ID}
                imageurl={program.IMAGE_URL}
                selectedImageurl={program.SELECTED_IMAGE_URL}
              >
                {/* <img
                  style={{
                    width: 30,
                    height: 30,
                    textAlign: "center",
                    margin: "3px 0px 6px 0px",
                  }}
                  src={"./images/1.png"}
                  alt={program.PROGRAM_NAME}
                /> */}
                {program.PROGRAM_NAME}
              </li>
              // <li>{program.PROGRAM_NAME}</li>
            ))}
          </ul>
          {program.map((program) => (
            <MenuDiv
              id={program.PROGRAM_ID}
              name={program.PROGRAM_NAME}
              selected={selectedProgramName}
            />
          ))}
        </Tabs>
      </div>
    </>
  );
}

// export default withRouter(Home);
export default Home;
